import Category from './Category'
import './Category.css'

export default Category



// WEBPACK FOOTER //
// ./src/features/RestaurantAndCafe/containers/Category/index.js